import React from "react"

import { Container, Row, Card } from "react-bootstrap"

import NavTabs from "@/singleProperty/navTabs"

import PropertySummary from "@/singleProperty/propertySummary"

function SinglePropertyCard({ property }) {
    return (
        <>
            <Container fluid="md" as={Card} className="p-0 pb-xxl-3 ps-xl-5 ">
                <Row className="m-0">
                    <NavTabs property={property} />

                    <PropertySummary property={property} />
                </Row>
            </Container>
        </>
    )
}

export default SinglePropertyCard
